export default __webpack_public_path__ + "static/media/loginVector.329d6da7.png";